module.exports = __webpack_public_path__ + "img/OldTownVapor.7e3f91c4.jpg";